export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

export const REQUEST_INVITE_INFO = 'REQUEST_INVITE_INFO';
export const RECEIVE_INVITE_INFO = 'RECEIVE_INVITE_INFO';

export const REQUEST_SP_INFO = 'REQUEST_SP_INFO';
export const RECEIVE_SP_INFO = 'RECEIVE_SP_INFO';
export const REQUEST_SAVE_SP_INFO = 'REQUEST_SAVE_SP_INFO';
export const RECEIVE_SAVE_SP_INFO = 'RECEIVE_SAVE_SP_INFO';

export const UPDATE_INFO_NAME = 'UPDATE_INFO_NAME';
export const UPDATE_INFO_CONTACTOR = 'UPDATE_INFO_CONTACTOR';

export const UPDATE_WECHAT_APP_ID = 'UPDATE_WECHAT_APP_ID';
export const UPDATE_WECHAT_APP_SECRET = 'UPDATE_WECHAT_APP_SECRET';
export const UPDATE_WECHAT_ENCODING_AES_KEY = 'UPDATE_WECHAT_ENCODING_AES_KEY';

export const REQUEST_WECHAT_INFO = 'REQUEST_WECHAT_INFO';
export const RECEIVE_WECHAT_INFO = 'RECEIVE_WECHAT_INFO';
export const REQUEST_SAVE_WECHAT_INFO = 'REQUEST_SAVE_WECHAT_INFO';
export const RECEIVE_SAVE_WECHAT_INFO = 'RECEIVE_SAVE_WECHAT_INFO';

export const REQUEST_WECHAT_CLEAR_SETTING = 'REQUEST_WECHAT_CLEAR_SETTING';
export const RECEIVE_WECHAT_CLEAR_SETTING = 'RECEIVE_WECHAT_CLEAR_SETTING';

export const REQUEST_FORM_LIST = 'REQUEST_FORM_LIST';
export const RECEIVE_FORM_LIST = 'RECEIVE_FORM_LIST';
export const REQUEST_SHARED_FORM_LIST = 'REQUEST_SHARED_FORM_LIST';
export const RECEIVE_SHARED_FORM_LIST = 'RECEIVE_SHARED_FORM_LIST';
export const REQUEST_SAVE_FORM_INFO = 'REQUEST_SAVE_FORM_INFO';
export const RECEIVE_SAVE_FORM_INFO = 'RECEIVE_SAVE_FORM_INFO';
export const REQUEST_FORM_INFO = 'REQUEST_FORM_INFO';
export const RECEIVE_FORM_INFO = 'RECEIVE_FORM_INFO';
export const REQUEST_DEFAULT_FORM_INFO = 'REQUEST_DEFAULT_FORM_INFO';
export const RECEIVE_DEFAULT_FORM_INFO = 'RECEIVE_DEFAULT_FORM_INFO';

export const REQUEST_MY_TICKET_LIST = 'REQUEST_MY_TICKET_LIST';
export const RECEIVE_MY_TICKET_LIST = 'RECEIVE_MY_TICKET_LIST';

export const REQUEST_TICKET_DETAIL = 'REQUEST_TICKET_DETAIL';
export const RECEIVE_TICKET_DETAIL = 'RECEIVE_TICKET_DETAIL';

// export const REQUEST_UPDATE_TICKET_PROGRESS = 'REQUEST_UPDATE_TICKET_PROGRESS';

export const REQUEST_CHANGE_PASSWORD = 'REQUEST_CHANGE_PASSWORD';
export const RECEIVE_CHANGE_PASSWORD = 'RECEIVE_CHANGE_PASSWORD';

export const REQUEST_CREATE_WECHAT_MENU = 'REQUEST_CREATE_WECHAT_MENU';
export const RECEIVE_CREATE_WECHAT_MENU = 'RECEIVE_CREATE_WECHAT_MENU';

export const REQUEST_FETCH_WECHAT_MENU = 'REQUEST_FETCH_WECHAT_MENU';
export const RECEIVE_FETCH_WECHAT_MENU = 'RECEIVE_FETCH_WECHAT_MENU';

export const REQUEST_BIND_YHL_TEAM = 'REQUEST_BIND_YHL_TEAM';
export const RECEIVE_BIND_YHL_TEAM = 'RECEIVE_BIND_YHL_TEAM';

export const REQUEST_APPLY_SUB_DOMAIN = 'REQUEST_APPLY_SUB_DOMAIN';
export const RECEIVE_APPLY_SUB_DOMAIN = 'RECEIVE_APPLY_SUB_DOMAIN';

export const REQUEST_SUBDOMAIN_LIST = 'REQUEST_SUBDOMAIN_LIST';
export const RECEIVE_SUBDOMAIN_LIST = 'RECEIVE_SUBDOMAIN_LIST';

export const REQUEST_ACCOUNT_INFO = 'REQUEST_ACCOUNT_INFO';
export const RECEIVE_ACCOUNT_INFO = 'RECEIVE_ACCOUNT_INFO';

export const REQUEST_ACCOUNT_RENEW = 'REQUEST_ACCOUNT_RENEW';
export const RECEIVE_ACCOUNT_RENEW = 'RECEIVE_ACCOUNT_RENEW';

export const REQUEST_ACCOUNT_SZ_LIST = 'REQUEST_ACCOUNT_SZ_LIST';
export const RECEIVE_ACCOUNT_SZ_LIST = 'RECEIVE_ACCOUNT_SZ_LIST';

export const REQUEST_SP_LIST = 'REQUEST_SP_LIST';
export const RECEIVE_SP_LIST = 'RECEIVE_SP_LIST';

export const REQUEST_SP_SETTING = 'REQUEST_SP_SETTING';
export const RECEIVE_SP_SETTING = 'RECEIVE_SP_SETTING';

export const REQUEST_SAVE_SP_SETTING = 'REQUEST_SAVE_SP_SETTING';
export const RECEIVE_SAVE_SP_SETTING = 'RECEIVE_SAVE_SP_SETTING';

export const REQUEST_FETCH_AUTHORIZER_LIST = 'REQUEST_FETCH_AUTHORIZER_LIST';
export const RECEIVE_FETCH_AUTHORIZER_LIST = 'RECEIVE_FETCH_AUTHORIZER_LIST';

export const REQUEST_SERVICE_TICKET_DETAIL = 'REQUEST_SERVICE_TICKET_DETAIL';
export const RECEIVE_SERVICE_TICKET_DETAIL = 'RECEIVE_SERVICE_TICKET_DETAIL';

export const REQUEST_FETCH_TICKET_STEPS = 'REQUEST_FETCH_TICKET_STEPS';
export const RECEIVE_FETCH_TICKET_STEPS = 'RECEIVE_FETCH_TICKET_STEPS';

export const REQUEST_RM_LIST = 'REQUEST_RM_LIST';
export const RECEIVE_RM_LIST = 'RECEIVE_RM_LIST';




// WEBPACK FOOTER //
// ./src/store/mutation-types.js